import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { API_URL } from '../config/index';

const SequelizeDashboard = () => {
  const [loading, setLoading] = useState(true);
  const [models, setModels] = useState({});
  const [schemaIssues, setSchemaIssues] = useState({});
  const [hasIssues, setHasIssues] = useState(false);
  const [stats, setStats] = useState({});
  const [activeTab, setActiveTab] = useState('models');
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    // Verificar se o usuário é administrador
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const isUserAdmin = user.email === 'admin@example.com';
    setIsAdmin(isUserAdmin);
    
    if (isUserAdmin) {
      fetchData();
    } else {
      setLoading(false);
    }
  }, []);

  const fetchData = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      if (!token) return;

      // Buscar modelos
      const modelsResponse = await axios.get(`${API_URL}/admin/sequelize/models`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setModels(modelsResponse.data.models || {});

      // Verificar esquema
      const schemaResponse = await axios.get(`${API_URL}/admin/sequelize/check-schema`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setSchemaIssues(schemaResponse.data.schemaIssues || {});
      setHasIssues(schemaResponse.data.hasIssues || false);

      // Buscar estatísticas
      const statsResponse = await axios.get(`${API_URL}/admin/sequelize/stats`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setStats(statsResponse.data.stats || {});
    } catch (error) {
      console.error('Erro ao buscar dados do Sequelize:', error);
    } finally {
      setLoading(false);
    }
  };

  if (!isAdmin) {
    return (
      <div className="page">
        <div className="page-wrapper">
          <div className="page-body">
            <div className="container-xl">
              <div className="card">
                <div className="card-body">
                  <div className="empty">
                    <div className="empty-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-lock" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                        <rect x="5" y="11" width="14" height="10" rx="2"></rect>
                        <circle cx="12" cy="16" r="1"></circle>
                        <path d="M8 11v-4a4 4 0 0 1 8 0v4"></path>
                      </svg>
                    </div>
                    <p className="empty-title">Acesso Restrito</p>
                    <p className="empty-subtitle text-muted">
                      Você não tem permissão para acessar esta página.
                    </p>
                    <div className="empty-action">
                      <Link to="/" className="btn btn-primary">
                        Voltar para o Dashboard
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="page-header d-print-none">
          <div className="container-xl">
            <div className="row g-2 align-items-center">
              <div className="col">
                <h2 className="page-title">
                  Dashboard do Sequelize
                </h2>
              </div>
              <div className="col-auto ms-auto">
                <div className="btn-list">
                  <Link to="/" className="btn btn-primary d-none d-sm-inline-block">
                    <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-arrow-left" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                      <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                      <path d="M5 12l14 0"></path>
                      <path d="M5 12l6 6"></path>
                      <path d="M5 12l6 -6"></path>
                    </svg>
                    Voltar para Dashboard
                  </Link>
                  <Link to="/" className="btn btn-primary d-sm-none btn-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-arrow-left" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                      <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                      <path d="M5 12l14 0"></path>
                      <path d="M5 12l6 6"></path>
                      <path d="M5 12l6 -6"></path>
                    </svg>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="page-body">
          <div className="container-xl">
            {loading ? (
              <div className="card">
                <div className="card-body text-center">
                  <div className="spinner-border text-primary" role="status"></div>
                  <p className="mt-3">Carregando dados do Sequelize...</p>
                </div>
              </div>
            ) : (
              <>
                <div className="card">
                  <div className="card-header">
                    <ul className="nav nav-tabs card-header-tabs">
                      <li className="nav-item">
                        <a 
                          className={`nav-link ${activeTab === 'models' ? 'active' : ''}`}
                          onClick={() => setActiveTab('models')}
                          href="#"
                        >
                          Modelos
                        </a>
                      </li>
                      <li className="nav-item">
                        <a 
                          className={`nav-link ${activeTab === 'schema' ? 'active' : ''}`}
                          onClick={() => setActiveTab('schema')}
                          href="#"
                        >
                          Verificação de Esquema
                          {hasIssues && (
                            <span className="badge bg-red ms-2">
                              {Object.keys(schemaIssues).length}
                            </span>
                          )}
                        </a>
                      </li>
                      <li className="nav-item">
                        <a 
                          className={`nav-link ${activeTab === 'stats' ? 'active' : ''}`}
                          onClick={() => setActiveTab('stats')}
                          href="#"
                        >
                          Estatísticas
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div className="card-body">
                    {activeTab === 'models' && (
                      <div className="models-tab">
                        <div className="accordion" id="modelsAccordion">
                          {Object.keys(models).map((modelName, index) => (
                            <div className="accordion-item" key={modelName}>
                              <h2 className="accordion-header">
                                <button 
                                  className="accordion-button collapsed" 
                                  type="button" 
                                  data-bs-toggle="collapse" 
                                  data-bs-target={`#model-${index}`}
                                >
                                  {modelName}
                                </button>
                              </h2>
                              <div 
                                id={`model-${index}`} 
                                className="accordion-collapse collapse" 
                                data-bs-parent="#modelsAccordion"
                              >
                                <div className="accordion-body">
                                  <h5>Atributos</h5>
                                  <table className="table table-vcenter table-striped">
                                    <thead>
                                      <tr>
                                        <th>Nome</th>
                                        <th>Tipo</th>
                                        <th>Permite Nulo</th>
                                        <th>Padrão</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {Object.entries(models[modelName].attributes).map(([attrName, attr]) => (
                                        <tr key={attrName}>
                                          <td>{attrName}</td>
                                          <td>{attr.type}</td>
                                          <td>{attr.allowNull ? 'Sim' : 'Não'}</td>
                                          <td>{attr.defaultValue !== undefined ? String(attr.defaultValue) : '-'}</td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>

                                  <h5 className="mt-4">Associações</h5>
                                  {models[modelName].associations.length === 0 ? (
                                    <p>Nenhuma associação definida</p>
                                  ) : (
                                    <ul className="list-group">
                                      {models[modelName].associations.map(assoc => (
                                        <li className="list-group-item" key={assoc.name}>
                                          <strong>{assoc.name}</strong>: {assoc.type}
                                        </li>
                                      ))}
                                    </ul>
                                  )}
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}

                    {activeTab === 'schema' && (
                      <div className="schema-tab">
                        {!hasIssues ? (
                          <div className="alert alert-success">
                            <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-check" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                              <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                              <path d="M5 12l5 5l10 -10"></path>
                            </svg>
                            <span>Nenhum problema encontrado no esquema do banco de dados!</span>
                          </div>
                        ) : (
                          <div>
                            <div className="alert alert-warning">
                              <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-alert-triangle" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                <path d="M12 9v2m0 4v.01"></path>
                                <path d="M5 19h14a2 2 0 0 0 1.84 -2.75l-7.1 -12.25a2 2 0 0 0 -3.5 0l-7.1 12.25a2 2 0 0 0 1.75 2.75"></path>
                              </svg>
                              <span>Foram encontrados problemas no esquema do banco de dados!</span>
                            </div>

                            {Object.entries(schemaIssues).map(([modelName, issue]) => (
                              <div className="card mb-3" key={modelName}>
                                <div className="card-header">
                                  <h5 className="card-title">Modelo: {modelName}</h5>
                                  <h6 className="card-subtitle text-muted">Tabela: {issue.tableName}</h6>
                                </div>
                                <div className="card-body">
                                  <h6>Colunas ausentes no banco de dados:</h6>
                                  <table className="table table-vcenter table-striped">
                                    <thead>
                                      <tr>
                                        <th>Nome da Coluna</th>
                                        <th>Tipo</th>
                                        <th>Permite Nulo</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {issue.missingColumns.map(col => (
                                        <tr key={col.name}>
                                          <td>{col.name}</td>
                                          <td>{col.type}</td>
                                          <td>{col.allowNull ? 'Sim' : 'Não'}</td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>
                                  
                                  <div className="mt-3">
                                    <h6>SQL para corrigir:</h6>
                                    <pre className="bg-dark text-white p-3 rounded">
                                      {issue.missingColumns.map(col => (
                                        `ALTER TABLE ${issue.tableName} ADD COLUMN IF NOT EXISTS ${col.name} ${col.type} ${col.allowNull ? 'NULL' : 'NOT NULL'};`
                                      )).join('\n')}
                                    </pre>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    )}

                    {activeTab === 'stats' && (
                      <div className="stats-tab">
                        <table className="table table-vcenter table-striped">
                          <thead>
                            <tr>
                              <th>Modelo</th>
                              <th>Registros</th>
                            </tr>
                          </thead>
                          <tbody>
                            {Object.entries(stats).map(([modelName, stat]) => (
                              <tr key={modelName}>
                                <td>{modelName}</td>
                                <td>{stat.count}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SequelizeDashboard; 